
export abstract class PayProcessServiceVM {

  public abstract payProcess(wixStatus: boolean): Promise<any>;

  public abstract validaPagoEjecutivo(): Promise<boolean>;

}
